import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VApp,[_c('div',{class:{ 'd-none': _vm.isPageLoaderShown }},[_c('router-view')],1),_c('PageLoader',{attrs:{"is-shown":_vm.isPageLoaderShown}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }